import { render } from "./FeedbackPositive.vue?vue&type=template&id=f0398b0c&scoped=true"
import script from "./FeedbackPositive.vue?vue&type=script&lang=js"
export * from "./FeedbackPositive.vue?vue&type=script&lang=js"

import "./FeedbackPositive.vue?vue&type=style&index=0&id=f0398b0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0398b0c"]])

export default __exports__